// ABOUTME: Hook to handle keyboard appearance and viewport adjustments
// Prevents content from being hidden behind the keyboard on mobile

import { useEffect } from 'react';

export const useKeyboardAdjust = () => {
  useEffect(() => {
    // Adjust viewport when keyboard appears/disappears
    const handleViewportChange = () => {
      // Force recalculation of viewport height
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Initial calculation
    handleViewportChange();

    // Listen for viewport changes (keyboard open/close)
    window.addEventListener('resize', handleViewportChange);

    // Visual viewport API for better keyboard detection
    if ('visualViewport' in window) {
      window.visualViewport?.addEventListener('resize', handleViewportChange);
    }

    // Prevent iOS keyboard from pushing content up too much
    const preventScroll = (e: TouchEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        window.scrollTo(0, scrollTop);
      }
    };

    document.addEventListener('touchmove', preventScroll, { passive: false });

    return () => {
      window.removeEventListener('resize', handleViewportChange);
      window.visualViewport?.removeEventListener('resize', handleViewportChange);
      document.removeEventListener('touchmove', preventScroll);
    };
  }, []);
};
